import React from 'react';
import IncomingRequests from './IncomingRequests/Index';

interface CandidateIncomingRequestsProps {
  id: number;
  name: string;
  sub_title: string;
  email?: string;
  icon?: string;
  score?: number;
  culture_score?: number;
  date: string;
  responded_at?: string;
  industry?: any[];
  stage?: number;
  status: number;
  jobId?: number;
  candidateId?: number;
  handleOpenModal: (id: number, type: string) => void;
  handleAccept: (id: number) => void;
  handleDecline: (id: number) => void;
}

const CandidateIncomingRequests: React.FC<CandidateIncomingRequestsProps> = (
  props
) => {
  const { handleAccept, handleDecline, handleOpenModal, ...rest } = props;
  return (
    <IncomingRequests
      {...rest}
      isCandidate={true}
      acceptRequest={handleAccept}
      declineRequest={handleDecline}
      setOpen={handleOpenModal}
    />
  );
};

export default CandidateIncomingRequests;
